import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

axios.defaults.timeout = 30000

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const adsSimulatorApi = {
  getAdsSimulator: (request) => {
    const { pageId, config } = request
    const url = `/${pageId}/messenger-ads-simulator`
    return instance().get(url, { params: config })
  },
  postAdsSimulator: (request) => {
    const { pageId, data } = request
    const url = `/${pageId}/messenger-ads-simulator`
    return instance().post(url, data)
  },
  putAdsSimulator: (request) => {
    const { pageId, data, adsId } = request
    const url = `/${pageId}/messenger-ads-simulator/${adsId}`
    return instance().put(url, data)
  },
  deleteAdsSimulator: (request) => {
    const { pageId, adsId } = request
    const url = `/${pageId}/messenger-ads-simulator/${adsId}`
    return instance().delete(url)
  }
}

export default adsSimulatorApi



// WEBPACK FOOTER //
// ./src/api/ads-simulator.js